import DefaultItemImage from "./images/dashboard/default-item-image.jpg";
import DefaultEditItemImage from "./images/dashboard/default-edit-item-image.png";
import PencilImage from "./images/dashboard/pencil.png";
import DeleteIcon from "./svg/delete-icon.svg";
import EditIcon from "./svg/edit-icon.svg";
import DefaultItemIcon from "./svg/default-item-icon.svg";
import EditItemIcon from "./svg/edit-item-icon.svg";
import SearchIcon from "./svg/search-icon.svg";
import DeleteIconRed from "./svg/delete-icon-red.svg";
import PlusIcon from "./svg/plus-icon.svg";
import TrashIcon from "./svg/trash-icon-transparent.svg";
import InputArrowIcon from "./svg/input-arrow-icon.svg";

// Export grouped by type for clarity
export const IMAGES = {
  DefaultItemImage,
  DefaultEditItemImage,
  PencilImage,
};
export const ICONS = {
  DeleteIcon,
  EditIcon,
  DefaultItemIcon,
  EditItemIcon,
  SearchIcon,
  DeleteIconRed,
  PlusIcon,
  TrashIcon,
  InputArrowIcon
};